import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_carbon-removal-dev/artifacts/m5iu0uf8_0604.mp4";
const POSTER =
  "https://images.pexels.com/photos/4750315/pexels-photo-4750315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export const VideoSection = () => {
  const { t } = useLang();
  const v = t.video;

  return (
    <section id="video" className="bg-white border-b border-border" data-testid="video-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <Reveal>
          <Overline>{v.label}</Overline>
          <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-nero-ink leading-[1.05] max-w-3xl">
            {v.title}
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 border border-border bg-nero-black">
            <video
              className="w-full h-auto block"
              controls
              preload="metadata"
              playsInline
              poster={POSTER}
              data-testid="intro-video"
            >
              <source src={VIDEO_URL} type="video/mp4" />
            </video>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
